export var EventDetailGridSize;
(function (EventDetailGridSize) {
    EventDetailGridSize[EventDetailGridSize["SMALL"] = 4] = "SMALL";
    EventDetailGridSize[EventDetailGridSize["MEDIUM"] = 6] = "MEDIUM";
    EventDetailGridSize[EventDetailGridSize["LIST"] = 12] = "LIST";
})(EventDetailGridSize || (EventDetailGridSize = {}));
